import { useState, useEffect } from "react";
import { Form } from "react-bootstrap";

const PASSCODE_LENGTH = 6;
const BREAKPOINT = PASSCODE_LENGTH / 2;

const OnetimePassword = ({ label = null, observer }) => {
  const [passcode, setPasscode] = useState("");
  const [displayPasscode, setDisplayPasscode] = useState("");
  useEffect(() => {
    const newPasscode = displayPasscode.replaceAll(" ", "");
    setPasscode(newPasscode);
    // 末尾の半角スペースを削除した場合、3文字目も削除して2文字にする
    if (displayPasscode.length === BREAKPOINT && (displayPasscode === passcode)) {
      setDisplayPasscode(displayPasscode.slice(0, BREAKPOINT - 1));
      return;
    }
    // 3文字以上入力されている場合、半角スペースを挿入する
    if (newPasscode.length >= BREAKPOINT && (displayPasscode.slice(BREAKPOINT, BREAKPOINT + 1) !== " ")) {
      setDisplayPasscode(`${newPasscode.slice(0, BREAKPOINT)} ${newPasscode.slice(BREAKPOINT, PASSCODE_LENGTH)}`);
      return;
    }
  }, [displayPasscode]);
  useEffect(() => {
    if (observer) {
      observer({ code: passcode, valid: passcode.length === PASSCODE_LENGTH });
    }
  }, [passcode]);

  return <Form.Group className="text-center">
    {Boolean(label) && (<Form.Label>{label}</Form.Label>)}
    <Form.Control
      type="text"
      value={displayPasscode}
      onChange={(event) => setDisplayPasscode(event.target.value)}
      onSelect={(event) => event.preventDefault()}
      className="text-center fs-3 d-inline-block"
      style={{ width: "12em" }}
      maxLength="7"
    />
  </Form.Group>;
};

export default OnetimePassword;